const https = window.location.protocol === 'https:'

/**
 * Delete cookie
 * @param name Cookie's name without __Host- prefix
 */
export const deleteCookie = function (name: string) {
  name = https ? '__Host-' + name : name
  const date = new Date()
  date.setDate(date.getDate() - 1)
  const yesterday = date.toUTCString()
  const secure = https ? '; Secure' : ''

  // Notice: "Domain" is not used when using "__Host-" -prefix (delete will fail if used)
  // prettier-ignore
  document.cookie =
    name + '=' +
    '; Max-Age=0' +
    '; Path=/' +
    '; Expires=' + yesterday +
    '; SameSite=strict' +
    secure
}

/**
 * Get cookie
 * @param name Cookie's name without __Host- prefix
 * @returns Cookie's value
 */
export const getCookie = (name: string): string | undefined => {
  name = https ? '__Host-' + name + '=' : name + '='
  const documentCookie = document.cookie + ';'
  const start = documentCookie.indexOf(name)

  return start > -1
    ? decodeURIComponent(
        documentCookie.substring(
          start + name.length,
          documentCookie.indexOf(';', start)
        )
      )
    : undefined
}

/**
 * Has cookie
 * @param name Cookie's name
 * @returns boolean
 */
export const hasCookie = (name: string): boolean =>
  undefined !== getCookie(name)

/**
 * Set cookie
 * @param name Cookie's name without __Host- prefix
 * @param value
 * @param maxAge in milliseconds (optional)
 */
export const setCookie = function (
  name: string,
  value: string,
  maxAge?: string
) {
  name = https ? '__Host-' + name : name
  const secure = https ? '; Secure' : ''
  const maxage =
    maxAge && maxAge.length > 3 ? '; Max-Age=' + maxAge.slice(0, -3) : ''

  // Notice: "Domain" is not used when using "__Host-" -prefix
  // prettier-ignore
  document.cookie =
    name + '=' + value +
    maxage +
    '; Path=/' +
    '; SameSite=strict' +
    secure
}
